import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-button',
  imports: [CommonModule],
  templateUrl: './custom-button.component.html',
  styleUrl: './custom-button.component.scss',
})
export class CustomButtonComponent {
  @Input() text = '';
  @Input() state: 'positive' | 'warning' | 'standart' = 'standart';
  @Output() clicked = new EventEmitter<void>();

  click() {
    this.clicked.emit();
  }
}
